// import { Injectable, inject } from '@angular/core';
// import {
//   CanActivate,
//   ActivatedRouteSnapshot,
//   RouterStateSnapshot,
//   Router,
// } from '@angular/router';
// import { Observable } from 'rxjs';
// import { ApiService } from '../../../shared/src/lib/services/api.service';
//
// @Injectable({
//   providedIn: 'root',
// })
// export class AuthGuard implements CanActivate {
//   oApiService = inject(ApiService);
//   constructor(private routes: Router) {}
//
//   canActivate(
//     next: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot,
//   ): boolean {
//     let oUserData = this.oApiService.getUserToken();
//     if (oUserData != null) return true;
//     this.routes.navigate(['/authentication/login']);
//     return false;
//   }
// }

// auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {AuthService} from "../../../shared/src/lib/services/auth.service";


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const requiredPermission = route.data['permission']; // Permission required by the route
    if (!this.authService.isAuthenticated()) {
      // Navigate to login page if user is not authenticated
      this.router.navigate(['authentication/login']);
      return false;
    }

    if (requiredPermission && !this.authService.hasPermission(requiredPermission)) {
      // If the route requires a permission and the user doesn't have it
      this.router.navigate(['authentication/access-denied']); // Or redirect to a proper route
      return false;
    }

    return true; // User is allowed to access the route
  }
}
